import React from 'react'

// Local icon assets
const imgDiscountTag02 = "/icon/discount-tag-02.svg"
const imgMoneyExchange03 = "/icon/money-exchange-03.svg"
const imgCheckmarkBadge03 = "/icon/checkmark-badge-03.svg"
const imgPackageOpen = "/icon/package-open.svg"
const imgLine535 = "https://www.figma.com/api/mcp/asset/a1049ece-0ebd-408d-8378-31276fadb89f"

const bannerItems = [
  {
    icon: imgCheckmarkBadge03,
    text: 'Official Make.com Partner'
  },
  {
    icon: imgCheckmarkBadge03,
    text: 'Official Zapier Partner'
  },
  {
    icon: imgCheckmarkBadge03,
    text: 'Official n8n Partner'
  },
  {
    icon: imgMoneyExchange03,
    text: 'Automated Follow-up system'
  },
  {
    icon: 'bulk-messaging-icon',
    text: 'AI Bulk Messaging Campaigns'
  },
  {
    icon: imgPackageOpen,
    text: '7 day Free Trial'
  }
]

const Banner = () => {
  // Create multiple copies for truly seamless infinite scrolling
  // With 4 copies, animation moves -25% (one set), creating perfect seamless loop
  const duplicatedItems = [
    ...bannerItems,
    ...bannerItems,
    ...bannerItems,
    ...bannerItems
  ]

  return (
    <div className="w-full bg-[#01cd74] py-2 sm:py-2.5 overflow-hidden relative">
      <div className="flex items-center h-6 sm:h-6 animate-banner-scroll will-change-transform" style={{ width: 'max-content' }}>
        {duplicatedItems.map((item, index) => (
          <React.Fragment key={`banner-item-${index}`}>
            <div className="flex items-center gap-[6px] flex-shrink-0 px-3 sm:px-4 md:px-6">
              <div className="relative shrink-0 w-4 h-4 flex items-center justify-center text-[#1c2329]">
                {item.icon === 'bulk-messaging-icon' ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="w-full h-full">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6.75 15.25H4.5a3.75 3.75 0 0 1 0-7.5h2.25zm0 0a22.3 22.3 0 0 1 12.366 3.744l1.134.756V3.25l-1.134.756A22.3 22.3 0 0 1 6.75 7.75zM23.25 10v3m-16.5 2.25A7.24 7.24 0 0 0 9 20.5" />
                  </svg>
                ) : (
                  <img
                    src={item.icon}
                    alt=""
                    className="block max-w-none w-full h-full object-contain"
                  />
                )}
              </div>
              <p className="text-[11px] sm:text-xs md:text-[13px] font-medium text-[#1c2329] uppercase tracking-[0.26px] whitespace-nowrap leading-[1.5] font-mono">
                {item.text}
              </p>
            </div>
            <div className="flex items-center justify-center h-5 w-0 flex-shrink-0">
              <div className="flex-none rotate-90">
                <div className="h-0 relative w-5">
                  <div className="absolute inset-[-1px_0_0_0]">
                    <img
                      src={imgLine535}
                      alt=""
                      className="block max-w-none w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default Banner

